import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { IconButton, SxProps } from '@mui/material';
import Close from '@mui/icons-material/Close';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#292739',
  borderRadius: '25px',
  px: 8,
  py: 8,
  outline: 'none',
};

interface IBasicModalProps {
  children: JSX.Element;
  handleClose: () => void;
  open: boolean;
  keepOpen?: boolean;
  sx?: SxProps;
}

const BasicModal = ({
  children,
  handleClose,
  open,
  keepOpen,
  sx,
}: IBasicModalProps) => {
  return (
    <div>
      <Modal
        open={open}
        onClose={keepOpen ? undefined : handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, ...sx }}>
          {children}
          <IconButton
            sx={{ position: 'absolute', right: 20, top: 25 }}
            onClick={handleClose}
          >
            <Close sx={{ color: 'white' }} />
          </IconButton>
        </Box>
      </Modal>
    </div>
  );
};

export default BasicModal;
